export const Translations = {
    en: {
        field_required: 'Error: Required Field',
        footer_1: 'This app is in no way affiliated with Com2us©',
        footer_2: 'The brand Summoners War™ is a registered trademark of Com2us©',
        welcome_title: 'Welcome to EHPCalculator',
        welcome_subtitle: 'With this tool you can calculate the EHP of your monsters',
        what_is: 'What is EHP?',
        ehp_description: 'EHP stands for Effective HP and it is the result of the following equation:',
        choose_from_options: 'Choose from the following options:',
        option_1: 'I have the total DEF and HP of my mob, I just wanna insert those',
        option_2: 'I want to select a specific mob and just want to add DEF and HP given from my runes',
        tip: 'Default mob is Baleygr',
        hp_label: 'HP',
        defense_label: 'Defense',
        base_hp: 'Base HP',
        runes_stats: 'Runes bonus',
        total: 'Total',
        change: 'Change',
        back: 'Back',
        search: 'Search',
        flags_overlay_title: 'Guild and Arena flags',
        adjust_flags_values: 'Flags',
        flags_overlay: 'Flags overlay',
        close_flags_dialog: 'Close flags overlay',
        guild_level: 'Guild Level',
        open_menu: 'Menu',
        opens_in_a_dialog: '(opens in a dialog)',
        sidebar: 'Sidebar',
        sidebar_title: 'Menu',
        sidebar_link_homepage: 'Homepage',
        sidebar_link_bj5: 'Balegyr Damage Calculator',
        sidebar_link_credits: 'Credits',
        bale_damage_title: 'Damage Calculator',
        close_sidebar: 'Close Menu',
        sidebar_links: 'Navigation Links',
        spd_label: 'Speed',
        guardstone: 'Guardstone',
        crystal_altar: 'Crystal Altar',
        ancient_sword: 'Ancient Sword',
        fire_sanctuary: 'Fire Sanctuary',
        light_sanctuary: 'Light Sanctuary',
        fallen_ancient_guardian: 'Fallen Ancient Guardian',
        sky_tribe_totem: 'Sky Tribe Totem',
        fight_sets_label: 'Number of Fight sets',
        atk_leader_label: 'Atk% Leader',
        frontline_label: 'Nr Frontline units',
        atk_label: 'Atk',
        def_label: 'Def',
        cdmg_label: 'CDmg',
        skill_up_label: 'Number of Skill ups',
        artifact_atk_effect: 'Atk% Increase effect',
        artifact_s3_damage: 'Skill 3 Damage%',
        dmg_percentage_hp: 'Dmg% of HP',
        dmg_percentage_atk: 'Dmg% of ATK',
        dmg_percentage_def: 'Dmg% of DEF',
        dmg_percentage_spd: 'Dmg% of SPD',
        show_artifacts: 'Artifacts',
        damage: 'Damage',
        damage_helper: 'Damage is calculated for the last hit. Should be 32.5k or more for optimal results',
        label_language: 'Language',
        language_name: 'English'
    },
    es: {
        field_required: 'Error: campo obligatorio',
        footer_1: 'Esta aplicación no está afiliada de ninguna manera con Com2us ©',
        footer_2: 'La marca Summoners War ™ es una marca registrada de Com2us ©',
        welcome_title: 'Bienvenido a EHPCalculator',
        welcome_subtitle: 'Con esta herramienta puedes calcular el EHP de tus monstruos',
        what_is: '¿Qué es EHP?',
        ehp_description: 'EHP son las siglas de Effective HP y es el resultado de la siguiente ecuación:',
        choose_from_options: 'Elija entre las siguientes opciones:',
        option_1: 'Tengo la DEF y PV totales de mi mafia, solo quiero insertar esos',
        option_2: 'Quiero seleccionar una mafia específica y solo quiero agregar DEF y PV dados por mis runas',
        tip: 'El monstruo predeterminado es Baleygr',
        hp_label: 'PV',
        defense_label: 'Defense',
        base_hp: 'PV base',
        runes_stats: 'Bono de runas',
        total: 'Total',
        change: 'Cambio',
        back: 'Atrás',
        search: 'Buscar',
        flags_overlay_title: 'Banderas de gremio y arena',
        adjust_flags_values: 'Banderas',
        flags_overlay: 'Superposición de banderas',
        close_flags_dialog: 'Cerrar superposición de banderas',
        guild_level: 'Nivel de gremio',
        guardstone: 'Piedra de guardia',
        open_menu: 'Menú',
        opens_in_a_dialog: '(se abre en un diálogo)',
        sidebar: 'Barra lateral',
        sidebar_title: 'Menú',
        sidebar_link_homepage: 'Página principal',
        sidebar_link_bj5: 'Calculadora de daños de Balegyr',
        sidebar_link_credits: 'Créditos',
        bale_damage_title: 'Calculadora de daños',
        close_sidebar: 'Cerrar Menú',
        sidebar_links: 'Enlaces de navegación',
        spd_label: 'Velocidad',
        crystal_altar: 'Altar de cristal',
        ancient_sword: 'Espada antigua',
        fire_sanctuary: 'Santuario de fuego',
        light_sanctuary: 'Santuario de luz',
        fallen_ancient_guardian: 'Guardián antiguo caído',
        sky_tribe_totem: 'Tótem de la tribu del cielo',
        fight_sets_label: 'Nombre de Fight sets',
        atk_leader_label: 'Líder% Atk',
        frontline_label: 'Nr Frontline units',
        atk_label: 'Atk',
        def_label: 'Def',
        cdmg_label: 'CDmg',
        skill_up_label: 'Núm. De habilidades',
        artifact_atk_effect: 'Atk% Incremento del efecto',
        artifact_s3_damage: '% De daño de la habilidad 3',
        dmg_percentage_hp: '% De daño de HP',
        dmg_percentage_atk: '% De daño de ATK',
        dmg_percentage_def: '% De daño de DEF',
        dmg_percentage_spd: '% De daño de SPD',
        show_artifacts: 'Artefactos',
        damage: 'Dañar',
        damage_helper: 'El daño se calcula para el último golpe. Debe ser de 32.5k o más para obtener resultados óptimos',
        label_language: 'Idioma',
        language_name: 'Español'
    },
    it: {
        field_required: 'Errore: Campo obbligatorio',
        footer_1: 'Questa applicazione non è affiliata con Com2us©',
        footer_2: 'il brand Summoners War™ è un marchio registrato Com2us©',
        welcome_title: 'Benvenuto sul EHPCalculator',
        welcome_subtitle: 'Con questo strumento puoi calcolare l\'EHP dei tuoi mostri',
        what_is: 'Cos\'è l\'EHP?',
        ehp_description: 'EHP è l\'acronimo di Effective HP ed è il risultato della seguente equazione:',
        choose_from_options: 'Scegli cosa vuoi fare:',
        option_1: 'So i pv e la difesa totali del mio mostro, userò quelli',
        option_2: 'Voglio selezionare un mostro specifico e aggiungere pv e difesa dati dalle rune',
        tip: 'Il mostro di default è Baleygr',
        hp_label: 'PV',
        defense_label: 'Difesa',
        base_hp: 'PV iniziali',
        runes_stats: 'Bonus rune',
        total: 'Totale',
        change: 'Cambia',
        back: 'Indietro',
        search: 'Cerca',
        flags_overlay_title: 'Bandiere Gilda e Arena',
        adjust_flags_values: 'Bandiere',
        flags_overlay: 'Overlay delle bandiere',
        close_flags_dialog: 'Chiudi l\'overlay delle bandiere',
        guild_level: 'Livello gilda',
        guardstone: 'Pietra difesa',
        crystal_altar: 'Altare di cristallo',
        open_menu: 'Menu',
        opens_in_a_dialog: '(si apre in una dialog)',
        sidebar: 'Sidebar',
        sidebar_title: 'Menu',
        sidebar_link_homepage: 'Homepage',
        sidebar_link_bj5: 'Calcolo Danno Balegyr',
        sidebar_link_credits: 'Credits',
        bale_damage_title: 'Calcolo Danno',
        close_sidebar: 'Chiudi il Menu',
        sidebar_links: 'Link di navigazione',
        spd_label: 'Velocità',
        ancient_sword: 'Spada Antica',
        fire_sanctuary: 'Santuario del fuoco',
        light_sanctuary: 'Santuario della luce',
        fallen_ancient_guardian: 'Guardiano antico',
        sky_tribe_totem: 'Totem tribù del cielo',
        fight_sets_label: 'Numero di Fight sets',
        atk_leader_label: 'Atk% Leader',
        frontline_label: 'Nr Frontline units',
        atk_label: 'Atk',
        def_label: 'Def',
        cdmg_label: 'CDmg',
        skill_up_label: 'Numero di Skill ups',
        artifact_atk_effect: 'Incremento Atk%',
        artifact_s3_damage: 'Danno% Skill 3',
        dmg_percentage_hp: 'Dmg% in base agli HP',
        dmg_percentage_atk: 'Dmg% in base all\'ATK',
        dmg_percentage_def: 'Dmg% in base alla DEF',
        dmg_percentage_spd: 'Dmg% in base alla SPD',
        show_artifacts: 'Artefatti',
        damage: 'Danno',
        damage_helper: 'Il Danno è calcolato sull\'ultima hit. Dovrebbe essere 32+ o superiore per un risultato ottimale',
        label_language: 'Lingua',
        language_name: 'Italiano'
    },
    fr: {
        field_required: 'Erreur: champ obligatoire',
        footer_1: 'Cette application n\'est en aucun cas affiliée à Com2us ©',
        footer_2: 'La marque Summoners War ™ est une marque déposée de Com2us ©',
        welcome_title: 'Bienvenue sur EHPCalculator',
        welcome_subtitle: 'Avec cet outil, vous pouvez calculer l\'EHP de vos monstres',
        what_is: 'Qu\'est-ce que l\'EHP?',
        ehp_description: 'EHP signifie HP Efficace et est le résultat de l\'équation suivante:',
        choose_from_options: 'Choisissez parmi les options suivantes:',
        option_1: 'J\'ai la DEF et les PV totaux de ma foule, je veux juste les insérer',
        option_2: 'Je veux sélectionner un mob spécifique et je veux juste ajouter du DEF et des PV donnés par mes runes',
        tip: 'Le monstre par défaut est Baleygr',
        hp_label: 'PV',
        defense_label: 'Défense',
        base_hp: 'PV de base',
        runes_stats: 'Bonus de runes',
        total: 'Total',
        change: 'Changement',
        back: 'Retour',
        search: 'Chercher',
        flags_overlay_title: 'Drapeaux de guilde et d\'arène',
        adjust_flags_values: 'Drapeaux',
        flags_overlay: 'Superposition de drapeaux',
        close_flags_dialog: 'Fermer la superposition des drapeaux',
        guild_level: 'Niveau de guilde',
        guardstone: 'Pierre de garde',
        crystal_altar: 'Autel de cristal',
        open_menu: 'Menu',
        opens_in_a_dialog: '(s\'ouvre dans une boîte de dialogue)',
        sidebar: 'Barre latérale',
        sidebar_title: 'Menu',
        sidebar_link_homepage: 'Page d\'accueil',
        sidebar_link_bj5: 'Calculateur de dégâts Balegyr',
        sidebar_link_credits: 'Crédits',
        bale_damage_title: 'Calculateur de dommages',
        close_sidebar: 'Fermer le menu',
        sidebar_links: 'Liens de navigation',
        spd_label: 'La vitesse',
        ancient_sword: 'Ancienne épée',
        fire_sanctuary: 'Sanctuaire d\'incendie',
        light_sanctuary: 'Sanctuaire léger',
        fallen_ancient_guardian: 'Ancien gardien déchu',
        sky_tribe_totem: 'Totem de la tribu du ciel',
        fight_sets_label: 'Nombre de Fight sets',
        atk_leader_label: 'Atk% Leader',
        frontline_label: 'Nr Frontline units',
        atk_label: 'Atk',
        def_label: 'Def',
        cdmg_label: 'CDmg',
        skill_up_label: 'Nombre de compétences augmentées',
        artifact_atk_effect: 'Effet d\'augmentation d\'Atk%',
        artifact_s3_damage: 'Dégâts de la compétence 3%',
        dmg_percentage_hp: 'Dmg% de HP',
        dmg_percentage_atk: 'Dmg% de ATK',
        dmg_percentage_def: 'Dmg% de DEF',
        dmg_percentage_spd: 'Dmg% de SPD',
        show_artifacts: 'Artefacts',
        damage: 'Dommage',
        damage_helper: 'Les dégâts sont calculés pour le dernier coup. Doit être de 32.5k ou plus pour des résultats optimaux',
        label_language: 'Langue',
        language_name: 'Français'
    },
    de: {
        field_required: 'Fehler: Erforderliches Feld',
        footer_1: 'Diese App ist in keiner Weise mit Com2us © verbunden',
        footer_2: 'Die Marke Summoners War ™ ist eine eingetragene Marke von Com2us ©',
        welcome_title: 'Willkommen bei EHPCalculator',
        welcome_subtitle: 'Mit diesem Tool kannst du den EHP deiner Monster berechnen',
        what_is: 'Was ist EHP?',
        ehp_description: 'EHP steht für Effective HP und ist das DEF der folgenden Gleichung:',
        choose_from_options: 'Wählen Sie aus folgenden Optionen:',
        option_1: 'Ich habe die gesamte DEF und HP meines Mobs, ich möchte nur diese einfügen',
        option_2: 'Ich möchte einen bestimmten Mob auswählen und nur DEF und HP aus meinen Runen hinzufügen',
        tip: 'Standardmonster ist Baleygr',
        hp_label: 'HP',
        defense_label: 'DEF',
        base_hp: 'Basis HP',
        runes_stats: 'Runenbonus',
        total: 'Gesamt',
        change: 'Veränderung',
        back: 'Zurück',
        search: 'Suche',
        flags_overlay_title: 'Gilden- und Arena-Flaggen',
        adjust_flags_values: 'Flaggen',
        flags_overlay: 'Flaggen überlagern',
        close_flags_dialog: 'Flaggenüberlagerung schließen',
        guild_level: 'Gildenlevel',
        guardstone: 'Schutzstein',
        crystal_altar: 'Kristallaltar',
        open_menu: 'Menü',
        opens_in_a_dialog: '(wird in einem Dialog geöffnet)',
        sidebar: 'Seitenleiste',
        sidebar_title: 'Menu',
        sidebar_link_homepage: 'Startseite',
        sidebar_link_bj5: 'Balegyr Schadensrechner',
        sidebar_link_credits: 'Credits',
        bale_damage_title: 'Schadensrechner',
        close_sidebar: 'Menü schließen',
        sidebar_links: 'Navigationslinks',
        spd_label: 'Geschwindigkeit',
        ancient_sword: 'Altes Schwert',
        fire_sanctuary: 'Feuerschutzgebiet',
        light_sanctuary: 'Lichtheiligtum',
        fallen_ancient_guardian: 'Gefallener alter Wächter',
        sky_tribe_totem: 'Totem des Himmelsstammes',
        fight_sets_label: 'Anzahl der Kampf setzt',
        atk_leader_label: 'Atk% Leader',
        frontline_label: 'Nr Frontline units',
        atk_label: 'Atk',
        def_label: 'Def',
        cdmg_label: 'CDmg',
        skill_up_label: 'Anzahl der Fähigkeiten',
        artifact_atk_effect: 'Atk% Effekt erhöhen',
        artifact_s3_damage: 'Fähigkeit 3 ​​Schaden%',
        dmg_percentage_hp: 'Dmg% HP',
        dmg_percentage_atk: 'Dmg% ATK',
        dmg_percentage_def: 'Dmg% DEF',
        dmg_percentage_spd: 'Dmg% SPD',
        show_artifacts: 'Artefakte',
        damage: 'Schaden',
        damage_helper: 'Der Schaden wird für den letzten Treffer berechnet. Sollte 32.5k oder mehr betragen, um optimale Ergebnisse zu erzielen',
        label_language: 'Sprache',
        language_name: 'Deutsche'
    },
    ja: {
        field_required: 'エラー：必須フィールド',
        footer_1: 'このアプリはCom2us©とは一切関係ありません。',
        footer_2: 'ブランドSummonersWar™はCom2us©の登録商標です。',
        welcome_title: 'EHPCalculatorへようこそ',
        welcome_subtitle: 'このツールを使用すると、モンスターのEHPを計算できます',
        what_is: 'EHPとは何ですか？',
        ehp_description: 'EHPはEffectiveHPの略で、次の方程式の結果です。',
        choose_from_options: '次のオプションから選択します。',
        option_1: '私は暴徒の合計DEFとHPを持っています、私はそれらを挿入したいだけです',
        option_2: '特定の暴徒を選択し、ルーンから与えられたDEFとHPを追加したい',
        tip: 'デフォルトの暴徒はBaleygrです',
        hp_label: 'HP',
        defense_label: 'DEF',
        base_hp: 'ベースHP',
        runes_stats: 'ルーンボーナス',
        total: '合計',
        change: '変化する',
        back: 'バック',
        search: '探す',
        flags_overlay_title: 'ギルドとアリーナの旗',
        adjust_flags_values: 'フラグ',
        flags_overlay: 'フラグオーバーレイ',
        close_flags_dialog: 'クローズフラグオーバーレイ',
        guild_level: 'ギルドレベル',
        guardstone: 'ガードストーン',
        crystal_altar: 'クリスタル祭壇',
        open_menu: 'メニュー',
        opens_in_a_dialog: '（ダイアログで開きます）',
        sidebar: 'サイドバー',
        sidebar_title: 'メニュー',
        sidebar_link_homepage: 'ホームページ',
        sidebar_link_bj5: 'Balegyrダメージ計算機',
        sidebar_link_credits: 'クレジット',
        bale_damage_title: 'ダメージ計算機',
        close_sidebar: 'メニューを閉じる',
        sidebar_links: 'ナビゲーションリンク',
        spd_label: '速度',
        ancient_sword: '古代の剣',
        fire_sanctuary: '火の聖域',
        light_sanctuary: 'ライトサンクチュアリ',
        fallen_ancient_guardian: '堕ちた古代の守護者',
        sky_tribe_totem: 'スカイトライブトーテム',
        fight_sets_label: 'ファイトセットの数',
        atk_leader_label: 'Atk％リーダー',
        frontline_label: 'Nr最前線のユニット',
        atk_label: 'Atk',
        def_label: 'Def',
        cdmg_label: 'CDmg',
        skill_up_label: 'スキルアップの数',
        artifact_atk_effect: 'Atk％増加効果',
        artifact_s3_damage: 'スキル3ダメージ％',
        dmg_percentage_hp: 'HPのDmg％',
        dmg_percentage_atk: 'ATKのDmg％',
        dmg_percentage_def: 'DEFのDmg％',
        dmg_percentage_spd: 'SPDのDmg％',
        show_artifacts: 'アーティファクト',
        damage: 'ダメージ',
        damage_helper: 'ダメージは最後のヒットに対して計算されます。最適な結果を得るには、32.5k以上である必要があります',
        label_language: '言語',
        language_name: '日本語'
    },
    zh: {
        field_required: '错误：必填字段',
        footer_1: '此应用程序绝不隶属于Com2us©',
        footer_2: 'Summoners War™品牌是Com2us©的注册商标。',
        welcome_title: '欢迎使用EHPCalculator',
        welcome_subtitle: '使用此工具，您可以计算怪物的EHP',
        what_is: '什么是EHP？',
        ehp_description: 'EHP代表有效HP，它是以下等式的结果：',
        choose_from_options: '从以下选项中选择：',
        option_1: '我有暴民的总防御和HP，我只想插入那些',
        option_2: '我想选择一个特定的暴民，只想添加我的符文给定的防御和HP',
        tip: '默认暴民是Baleygr',
        hp_label: 'HP',
        defense_label: 'DEF',
        base_hp: '基础HP',
        runes_stats: '符文加成',
        total: '总',
        change: '更改',
        back: '背部',
        search: '搜索',
        flags_overlay_title: '公会和竞技场标志',
        adjust_flags_values: '标志',
        flags_overlay: '标志覆盖',
        close_flags_dialog: '关闭标志叠加',
        guild_level: '公会等级',
        guardstone: '护石',
        crystal_altar: '水晶祭坛',
        open_menu: '菜单',
        opens_in_a_dialog: '（在对话框中打开）',
        sidebar: '侧边栏',
        sidebar_title: '菜单',
        sidebar_link_homepage: '主页',
        sidebar_link_bj5: 'Balegyr伤害计算器',
        sidebar_link_credits: '学分',
        bale_damage_title: '伤害计算器',
        close_sidebar: '关闭选单',
        sidebar_links: '导航链接',
        spd_label: '速度',
        ancient_sword: '古剑',
        fire_sanctuary: '消防圣所',
        light_sanctuary: '避难所',
        fallen_ancient_guardian: '堕落的古代守护者',
        sky_tribe_totem: '天空部落图腾',
        fight_sets_label: '战斗台数',
        atk_leader_label: '攻击率领导者',
        frontline_label: 'Nr前线部队',
        atk_label: 'Atk',
        def_label: 'Def',
        cdmg_label: 'CDmg',
        skill_up_label: '技能数量',
        artifact_atk_effect: '攻击力增加效果',
        artifact_s3_damage: '技能3伤害％',
        dmg_percentage_hp: 'HP Dmg%',
        dmg_percentage_atk: 'ATK Dmg%',
        dmg_percentage_def: 'DEF Dmg%',
        dmg_percentage_spd: 'SPD Dmg%',
        show_artifacts: '伪像',
        damage: '损伤',
        damage_helper: '伤害是针对最后一次命中计算的。应该为32.5k或更高，以获得最佳结果',
        label_language: '语言',
        language_name: '中文'
    },
    ko: {
        field_required: '오류 : 필수 필드',
        footer_1: '이 앱은 Com2us ©와 전혀 관련이 없습니다.',
        footer_2: 'Summoners War ™ 브랜드는 Com2us ©의 등록 상표입니다.',
        welcome_title: 'EHPCalculator에 오신 것을 환영합니다',
        welcome_subtitle: '이 도구를 사용하면 몬스터의 EHP를 계산할 수 있습니다.',
        what_is: 'EHP 란 무엇입니까?',
        ehp_description: 'EHP는 유효 HP를 나타내며 다음 방정식의 결과입니다.',
        choose_from_options: '다음 옵션 중에서 선택하십시오.',
        option_1: '내 몹의 총 DEF와 HP를 가지고 있습니다.',
        option_2: '특정 몹을 선택하고 내 룬에서 주어진 DEF와 HP를 추가하고 싶습니다.',
        tip: '기본 군중은 Baleygr입니다.',
        hp_label: 'HP',
        defense_label: 'DEF',
        base_hp: '기본 HP',
        runes_stats: '룬 보너스',
        total: '합계',
        change: '변화',
        back: '뒤',
        search: '검색',
        flags_overlay_title: '길드 및 아레나 플래그',
        adjust_flags_values: '깃발',
        flags_overlay: '플래그 오버레이',
        close_flags_dialog: '플래그 오버레이 닫기',
        guild_level: '길드 레벨',
        guardstone: '가드 스톤',
        crystal_altar: '수정 제단',
        open_menu: '메뉴',
        opens_in_a_dialog: ' (대화 상자에서 열림)',
        sidebar: '사이드 바',
        sidebar_title: '메뉴',
        sidebar_link_homepage: '홈페이지',
        sidebar_link_bj5: '발레 기르 피해 계산기',
        sidebar_link_credits: '크레딧',
        bale_damage_title: '피해 계산기',
        close_sidebar: '메뉴 닫기',
        sidebar_links: '탐색 링크',
        spd_label: '속도',
        ancient_sword: '고대 검',
        fire_sanctuary: 'Fire Sanctuary',
        light_sanctuary: '빛의 성역',
        fallen_ancient_guardian: '타락한 고대 수호자',
        sky_tribe_totem: '하늘 부족 토템',
        fight_sets_label: '전투 세트 수',
        atk_leader_label: 'Atk % 리더',
        frontline_label: 'Nr 전선 부대',
        atk_label: 'Atk',
        def_label: 'Def',
        cdmg_label: 'CDmg',
        skill_up_label: '스킬 업 수',
        artifact_atk_effect: 'Atk % 증가 효과',
        artifact_s3_damage: '스킬 3 데미지 %',
        dmg_percentage_hp: 'HP의 데미지 %',
        dmg_percentage_atk: 'ATK의 데미지 %',
        dmg_percentage_def: 'DEF의 데미지 %',
        dmg_percentage_spd: 'SPD의 데미지 %',
        show_artifacts: '아티팩트',
        damage: '피해를 주다',
        damage_helper: '마지막 히트에 대한 피해가 계산됩니다. 최적의 결과를 얻으려면 32.5k 이상이어야합니다.',
        label_language: '언어',
        language_name: '한국어'
    }
}